import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import {
  Container as BaseContainer,
  topBorder,
  cardBase,
  PrimaryButton,
  SectionHeading,
  SectionSub
} from './GlobalStyle';
import { useI18n } from '../i18n';
import micuenca2 from '../assets/projects/micuenca2.webp';
import logoberrik from '../assets/projects/berrik_logo.webp';
import talentImg from '../assets/projects/talent.webp';

const Section = styled.section`
  padding: 4rem 2rem;
  background: ${({ theme }) => theme.colors.bgSubtle};
  ${topBorder}
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 3rem 1rem;
  }
`;

const Container = BaseContainer;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.25rem;
`;

const Card = styled.article`
  ${cardBase}
  overflow: hidden;
  display: flex;
  flex-direction: column;
  img {
    width: 100%;
    height: 160px;
    object-fit: cover;
  }
  .content {
    padding: 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    flex: 1;
  }
`;

const CardTitle = styled.h3`
  color: ${({ theme }) => theme.colors.brandDark};
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1.4;
`;

const CardDate = styled.time`
  color: ${({ theme }) => theme.colors.muted};
  font-size: 0.85rem;
`;

const CardAction = styled(PrimaryButton)`
  margin-top: auto;
  align-self: flex-start;
  padding: 0.5rem 1rem;
`;

const LatestUpdates = () => {
  const { t, lang } = useI18n();
  const formatDate = (iso) => {
    try {
      return new Intl.DateTimeFormat(lang === 'es' ? 'es-CL' : 'en-US', { dateStyle: 'long' })
        .format(new Date(`${iso}T00:00:00`));
    } catch {
      return iso;
    }
  };
  const updates = [
    { title: t('home.newsOpenClientsTitle'), date: '2026-02-09', image: logoberrik },
    { title: t('home.newsMicuencaRegionsTitle'), date: '2026-02-09', image: micuenca2 },
    { title: t('home.newsHiringTitle'), date: '2026-02-09', image: talentImg }
  ];
  return (
    <Section>
      <Container>
        <SectionHeading
          as={motion.h2}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          {t('home.latestUpdatesHeader')}
        </SectionHeading>
        <SectionSub>{t('home.latestUpdatesSub')}</SectionSub>
        <Grid>
          {updates.map((u) => (
            <Card key={u.title}>
              <img src={u.image} alt={u.title} loading="lazy" decoding="async" />
              <div className="content">
                <CardTitle>{u.title}</CardTitle>
                <CardDate dateTime={u.date}>{formatDate(u.date)}</CardDate>
                <CardAction to="/updates">{t('home.actionReadUpdate')}</CardAction>
              </div>
            </Card>
          ))}
        </Grid>
      </Container>
    </Section>
  );
};

export default LatestUpdates;
